import {
  Component,
  OnInit,
} from '@angular/core';


@Component({
  selector: 'app-picker-dialog',
  templateUrl: './picker-dialog.component.html',
  styleUrls: ['./picker-dialog.component.sass']
})
export class PickerDialogComponent<T> implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
